:host {
  display: block;
}

.results {
  display: block;
  padding: 0.5rem 1rem;
  background: var(--color-blue-green);
  margin: 1rem 0;
  color: var(--color-white);
  font-weight: var(--font-weight-bold);
}
.results ::slotted(a) {
  text-decoration: underline !important;
  color: var(--color-white) !important;
}
.results ::slotted(a:hover) {
  text-decoration: none !important;
  color: var(--color-white) !important;
}
.success {
  background: var(--color-blue-green);
  font-weight: var(--font-weight-bold);
}
.warning {
  background: var(--color-yellow);
  color: var(--color-black);
}
.warning ::slotted(a) {
  color: var(--color-black) !important;
}
.warning ::slotted(a:hover) {
  color: var(--color-black) !important;
}
.error {
  background: var(--color-orange);
}
.link-blue {
  background: var(--color-link-blue);
}
.cwru-blue {
  background: var(--color-cwru-blue);
}
